<template>
  <v-container grid-list-lg fluid px-0 py-0 my-0 mx-0>
    <v-layout row wrap modal__block>
      <span class="modal__close" @click="closeModal"></span>
      <v-flex xs12 modal__wrapper>
        <v-layout row wrap v-if="editMode">
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs4 pr-0>
                <v-text-field
                  v-model="bankBIK"
                  :label="$t('components.clients.bank.form.searchBank')"
                  class="mt-0 pt-0"
                ></v-text-field>
              </v-flex>
              <v-flex shrink pl-0>
                <v-btn color="primary" @click="getBankByBIK" icon>
                  <v-icon>search</v-icon>
                </v-btn>
              </v-flex>
              <v-flex shrink v-if="bankError">
                <h3 class="mt-3">{{ bankError }}</h3>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout row wrap :class="{ isBlocked: !editMode }">
          <v-flex xs12>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout form__row row wrap v-if="editMode">
                <v-flex xs12 text-left>
                  <h1>
                    {{ create ? $t('components.clients.bank.form.titleAdd') : $t('components.clients.bank.form.titleUpdate') }} 
                  </h1>
                </v-flex>
                <v-flex xs12 py-0>
                  <v-divider />
                </v-flex>
              </v-layout>

              <v-layout form__row row wrap v-else>
                <v-flex xs12 text-left>
                  <h1>{{$t('components.clients.bank.form.title')}}</h1>
                </v-flex>
                <v-flex xs12 py-0>
                  <v-divider />
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="bank.settlement_account"
                    :label="$t('components.clients.bank.form.account')"
                    :rules="rules.settlement_account"
                    :disabled="packageMode && !editMode"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="bank.bik"
                    :label="$t('components.clients.bank.table.bik')"
                    :rules="rules.bik"
                    :disabled="packageMode && !editMode"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="bank.correspondent_account"
                    :label="$t('components.clients.bank.form.correspondentAccount')"
                    :rules="rules.correspondent_account"
                    :disabled="packageMode && !editMode"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="bank.name"
                    :label="$t('components.clients.bank.table.name')"
                    :rules="rules.name"
                    :disabled="packageMode && !editMode"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row wrap v-if="editMode">
                <v-flex xs12>
                  <v-checkbox
                    v-model="bank.is_main"
                    :label="$t('components.clients.bank.form.isMain')"
                    :disabled="accountsTotal == 0"
                  ></v-checkbox>
                </v-flex>
              </v-layout>

              <v-layout form__row row wrap v-if="editMode || !packageMode">
                <v-flex xs12>
                  <v-btn
                    :disabled="bankSaveLoading"
                    :loading="bankSaveLoading"
                    @click="validate"
                    color="primary"
                    >{{ create ? $t('components.clients.bank.form.saveButton') : $t('components.clients.bank.form.updateButton') }}</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-form>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { apiCallTrue } from "@/utils/api";
import rules from "@/utils/data/rules";
import BankModel from "@/models/BankAccountModel";
import showNotify from "@/services/noty";

export default {
  name: "AddBank",
  data: () => ({
    valid: false,
    bank: {},
    bankSaveLoading: false,
    errors: {},
    bankBIK: "",
    bankError: null,
    rules,
  }),
  props: {
    publicHash: {
      type: String,
      default: "",
    },
    accountsTotal: {
      type: Number,
    },
    editedBank: {
      type: Object,
    },
    create: {
      type: Boolean,
    },
    editMode: {
      type: Boolean,
      default: true,
    },
    packageMode: {
      type: Boolean,
      default: false,
    },
    agentMode: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.saveBank();
      }
    },
    async saveBank() {
      const method = "POST";
      const data = this.bank;
      const inn = this.agentMode ? this.agentMode : false;
      this.bankSaveLoading = true;

      if (this.packageMode) {
        let url = "";
        if (this.publicHash) {
          url = this.create
            ? `v1/bank-accounts/save-by-hash/${this.publicHash}`
            : `v1/bank-accounts/${this.bank.id}/save-by-hash/${this.publicHash}`;
        } else {
          url = "v1/validate";
        }
        const params = this.publicHash ? null : { model: "bankAccounts", inn };

        await apiCallTrue({
          url,
          data,
          method,
          params,
        })
          .then((response) => {
            if (this.create) {
              this.addBank(response.data.data);
            } else {
              this.updateBank(response.data.data);
            }
          })
          .catch((error) => {
            this.errors = error;
            showNotify("error", error);
          })
          .finally(() => {
            this.bankSaveLoading = false;
          });
      } else {
        const url = this.create
          ? "v1/bank-accounts"
          : `v1/bank-accounts/${this.bank.id}`;
        const params = inn ? { inn } : {};

        await apiCallTrue({
          url,
          data,
          method,
          params,
        })
          .then((response) => {
            if (this.create) {
              this.addBank(response.data.data);
            } else {
              this.updateBank(response.data.data);
            }
          })
          .catch((error) => {
            this.errors = error;
            showNotify("error", error);
          })
          .finally(() => {
            this.bankSaveLoading = false;
          });
      }
    },
    updateBank(bank) {
      this.$emit("updateBanks", bank);
    },
    addBank(bank) {
      this.$emit("addBanks", bank);
    },
    getBankByBIK() {
      this.bankError = null;

      apiCallTrue({
        url: `v1/autocomplete/bank/${this.bankBIK}`,
      })
        .then((response) => {
          this.chooseThisBank(response.data.data[0].data);
        })
        .catch((error) => (this.bankError = error.message));
    },
    chooseThisBank(bank) {
      this.bank.bik = bank.bic;
      this.bank.name = bank.name.payment;
      this.bank.address = bank.address.value;
      this.bank.correspondent_account = bank.correspondent_account;
    },
    closeModal() {
      this.$emit("closeModal");
    },
  },
  mounted() {
    if (this.create && this.editedBank) {
      this.bank = new BankModel();
      this.$refs.form.reset();
    } else {
      this.bank = Object.assign({}, this.editedBank);
    }
  },
  watch: {
    create(val) {
      if (!val) {
        this.bank = Object.assign({}, this.editedBank);
      } else {
        this.bank = new BankModel();
        this.$refs.form.reset();
      }
      if (this.accountsTotal === 0) {
        this.bank.is_main = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// #app .v-menu__content {
//     box-shadow: 0 0 0;
// }
.bank {
  &__choose {
    color: #404ce6;
    font-weight: 700;
    cursor: pointer;
  }
}
</style>
